<div class="card" style="width:100%;" id="InsuredInfo">
    <ul class="nav nav-tabs listdata" role="tablist">
        <li role="presentation" class="active">
            <a href="#home" aria-controls="home" role="tab"
                data-toggle="tab">{{'Cover & Benefit Details' | translate }}</a>
        </li>
    </ul>
    <div class="tab-content domesticinsuredtab">
        <div role="tabpanel" class="tab-pane active" id="home">
            <div class="domesticinsuredinfo1 InsuredForm">

                <div class="DomesticField row ">
                    <div class="col-lg-12" style="border: 1px solid gray;margin-bottom:15px;">
                        <div class="col-lg-12 coverdetails">
                            <h5 class="cover1">{{'Repatriation Expenses' | translate}}</h5>
                        </div>


                        <div class="col-lg-12 Field">
                            <label class="AdditionalDrivers">
                                {{'Due to absconding? ' | translate }}
                            </label>
                            <label class="AdditionalDrivers">
                                <label>
                                    <input type="radio" name="absconding" id="rad1" [value]=3000
                                        (change)="AddCovers('501801',3000)" [(ngModel)]="MandatoryCover1" />
                                    {{'SR 3000'| translate }}
                                </label>
                                <label>
                                    <input type="radio" name="absconding" id="rad2" [value]=5000
                                        (change)="AddCovers('501801',5000)" [(ngModel)]="MandatoryCover1" />
                                    {{'SR 5000' | translate}}
                                </label>
                                <label>
                                    <input type="radio" name="absconding" id="rad3" [value]=10000
                                        (change)="AddCovers('501801',10000)" [(ngModel)]="MandatoryCover1" />
                                    {{'SR 10000'| translate }}
                                </label>
                                <label>
                                    <input type="radio" name="absconding" id="rad4" [value]=15000
                                        (change)="AddCovers('501801',15000)" [(ngModel)]="MandatoryCover1" />
                                    {{'SR 15000' | translate}}
                                </label>
                            </label>
                        </div>
                        <div class="col-lg-12 Field">
                            <label class="AdditionalDrivers">
                                {{'Due to Refusal to work? ' | translate }}
                            </label>
                            <label class="AdditionalDrivers">
                                <label>
                                    <input type="radio" name="RefusalToWork" id="ref1" [value]=3000
                                        (change)="AddCovers('501802',3000)" [(ngModel)]="MandatoryCover2" />
                                    {{'SR 3000'| translate }}
                                </label>
                                <label>
                                    <input type="radio" name="RefusalToWork" id="ref2" [value]=5000
                                        (change)="AddCovers('501802',5000)" [(ngModel)]="MandatoryCover2" />
                                    {{'SR 5000' | translate}}
                                </label>
                                <label>
                                    <input type="radio" name="RefusalToWork" id="ref3" [value]=10000
                                        (change)="AddCovers('501802',10000)" [(ngModel)]="MandatoryCover2" />
                                    {{'SR 10000'| translate }}
                                </label>
                                <label>
                                    <input type="radio" name="RefusalToWork" id="ref4" [value]=15000
                                        (change)="AddCovers('501802',15000)" [(ngModel)]="MandatoryCover2" />
                                    {{'SR 15000' | translate}}
                                </label>
                            </label>
                        </div>
                        <div class="col-lg-12 Field">
                            <label class="AdditionalDrivers">
                                {{'Due to Death? ' | translate }}
                            </label>
                            <label class="AdditionalDrivers">
                                <label>
                                    <input type="radio" name="Death" id="Death1" [value]=3000
                                        (change)="AddCovers('501803',3000)" [(ngModel)]="MandatoryCover3" />
                                    {{'SR 3000'| translate }}
                                </label>
                                <label>
                                    <input type="radio" name="Death" id="Death2" [value]=5000
                                        (change)="AddCovers('501803',5000)" [(ngModel)]="MandatoryCover3" />
                                    {{'SR 5000' | translate}}
                                </label>
                                <label>
                                    <input type="radio" name="Death" id="Death3" [value]=10000
                                        (change)="AddCovers('501803',10000)" [(ngModel)]="MandatoryCover3" />
                                    {{'SR 10000'| translate }}
                                </label>
                                <label>
                                    <input type="radio" name="Death" id="Death4" [value]=15000
                                        (change)="AddCovers('501803',15000)" [(ngModel)]="MandatoryCover3" />
                                    {{'SR 15000' | translate}}
                                </label>
                            </label>
                        </div>
                        <div class="col-lg-12 Field">
                            <label class="AdditionalDrivers">
                                {{'Due to permanent total or permanent partial disablement ? ' | translate }}
                            </label>
                            <label class="AdditionalDrivers">
                                <label>
                                    <input type="radio" name="Disablement" id="Disablement" [value]=3000
                                        (change)="AddCovers('501804',3000)" [(ngModel)]="MandatoryCover4" />
                                    {{'SR 3000'| translate }}
                                </label>
                                <label>
                                    <input type="radio" name="Disablement" id="Disablement" [value]=5000
                                        (change)="AddCovers('501804',5000)" [(ngModel)]="MandatoryCover4" />
                                    {{'SR 5000' | translate}}
                                </label>
                                <label>
                                    <input type="radio" name="Disablement" id="Disablement" [value]=10000
                                        (change)="AddCovers('501804',10000)" [(ngModel)]="MandatoryCover4" />
                                    {{'SR 10000'| translate }}
                                </label>
                                <label>
                                    <input type="radio" name="Disablement" id="Disablement" [value]=15000
                                        (change)="AddCovers('501804',15000)" [(ngModel)]="MandatoryCover4" />
                                    {{'SR 15000' | translate}}
                                </label>
                            </label>
                        </div>




                    </div>
                    <div class="col-lg-12" style="border: 1px solid gray;margin-bottom:15px;">
                        <div class="col-lg-12 coverdetails">
                            <h5 class="cover1">{{'Replacement Expenses' | translate}}</h5>
                        </div>
                        <div class="col-lg-12 Field">
                            <label class="AdditionalDrivers">
                                {{'Due to Personal Reasons ? ' | translate }}
                            </label>
                            <label class="AdditionalDrivers">
                                <label>
                                    <input type="radio" name="PersonalReasons" id="PersonalReasons1" [value]="3000"
                                        (change)="AddCovers('501805',3000)" /> {{'SR 3000'| translate }}
                                </label>
                                <label>
                                    <input type="radio" name="PersonalReasons" id="PersonalReasons2" [value]="5000"
                                        (change)="AddCovers('501805',5000)" /> {{'SR 5000' | translate}}
                                </label>
                                <label>
                                    <input type="radio" name="PersonalReasons" id="PersonalReasons3" [value]="10000"
                                        (change)="AddCovers('501805',10000)" /> {{'SR 10000'| translate }}
                                </label>
                                <label>
                                    <input type="radio" name="PersonalReasons" id="PersonalReasons4" [value]="15000"
                                        (change)="AddCovers('501805',15000)" /> {{'SR 15000' | translate}}
                                </label>
                                <label>
                                    <input type="radio" name="PersonalReasons" id="PersonalReasons4" [value]="15000"
                                        (change)="AddCovers('501805',0)" /> {{'None' | translate}}
                                </label>
                            </label>
                        </div>
                        <div class="col-lg-12 Field">
                            <label class="AdditionalDrivers">
                                {{'Due to Medical reasons ? ' | translate }}
                            </label>
                            <label class="AdditionalDrivers">
                                <label>
                                    <input type="radio" name="MedicalReasons" id="MedicalReasons1" [value]="3000"
                                        (change)="AddCovers('501806',3000)" /> {{'SR 3000'| translate }}
                                </label>
                                <label>
                                    <input type="radio" name="MedicalReasons" id="MedicalReasons2" [value]="5000"
                                        (change)="AddCovers('501806',5000)" /> {{'SR 5000' | translate}}
                                </label>
                                <label>
                                    <input type="radio" name="MedicalReasons" id="MedicalReasons3" [value]="10000"
                                        (change)="AddCovers('501806',10000)" /> {{'SR 10000'| translate }}
                                </label>
                                <label>
                                    <input type="radio" name="MedicalReasons" id="MedicalReasons4" [value]="15000"
                                        (change)="AddCovers('501806',15000)" /> {{'SR 15000' | translate}}
                                </label>
                                <label>
                                    <input type="radio" name="MedicalReasons" id="MedicalReasons4" [value]="15000"
                                        (change)="AddCovers('501806',0)" /> {{'None' | translate}}
                                </label>
                            </label>
                        </div>
                        <div class="col-lg-12 Field">
                            <label class="AdditionalDrivers">
                                {{'Due to Absconding ? ' | translate }}
                            </label>
                            <label class="AdditionalDrivers">
                                <label>
                                    <input type="radio" name="replacementabsconding" id="replacementabsconding1"
                                        [value]=3000 (change)="AddCovers('501807',3000)" />
                                    {{'SR 3000'| translate }}
                                </label>
                                <label>
                                    <input type="radio" name="replacementabsconding" id="replacementabsconding2"
                                        [value]=5000 (change)="AddCovers('501807',5000)" />
                                    {{'SR 5000' | translate}}
                                </label>
                                <label>
                                    <input type="radio" name="replacementabsconding" id="replacementabsconding3"
                                        [value]=10000 (change)="AddCovers('501807',10000)" />
                                    {{'SR 10000'| translate }}
                                </label>
                                <label>
                                    <input type="radio" name="replacementabsconding" id="replacementabsconding4"
                                        [value]=15000 (change)="AddCovers('501807',15000)" />
                                    {{'SR 15000' | translate}}
                                </label>
                                <label>
                                    <input type="radio" name="replacementabsconding" id="replacementabsconding4"
                                        [value]=0 (change)="AddCovers('501807',0)" />
                                    {{'None' | translate}}
                                </label>
                            </label>
                        </div>
                    </div>
                    <div class="col-lg-12" style="border: 1px solid gray;margin-bottom:15px;">
                        <div class="col-lg-12 coverdetails">
                            <h5 class="cover1">{{'Compensation Benefits(For Beneficiary)' | translate}}</h5>
                        </div>

                        <div class="col-lg-12 Field">
                            <label class="AdditionalDrivers">
                                {{'Due to Accidental Death ? ' | translate }}
                            </label>
                            <label class="AdditionalDrivers">
                                <label>
                                    <input type="radio" name="AccidentalDeath" id="AccidentalDeath1" [value]=3000
                                        (change)="AddCovers('501808',3000)" />
                                    {{'SR 3000'| translate }}
                                </label>
                                <label>
                                    <input type="radio" name="AccidentalDeath" id="AccidentalDeath2" [value]=5000
                                        (change)="AddCovers('501808',5000)" />
                                    {{'SR 5000' | translate}}
                                </label>
                                <label>
                                    <input type="radio" name="AccidentalDeath" id="AccidentalDeath3" [value]=10000
                                        (change)="AddCovers('501808',10000)" />
                                    {{'SR 10000'| translate }}
                                </label>
                                <label>
                                    <input type="radio" name="AccidentalDeath" id="AccidentalDeath4" [value]=15000
                                        (change)="AddCovers('501808',15000)" />
                                    {{'SR 15000' | translate}}
                                </label>
                                <label>
                                    <input type="radio" name="AccidentalDeath" id="AccidentalDeath4" [value]=0
                                        (change)="AddCovers('501808',0)" />
                                    {{'None' | translate}}
                                </label>
                            </label>
                        </div>

                        <div class="col-lg-12 Field">
                            <label class="AdditionalDrivers">
                                {{'Due to permanent total or permanent partial disablement of the insured person ? ' | translate }}
                            </label>
                            <label class="AdditionalDrivers">
                                <label>
                                    <input type="radio" name="PartialDisablementForInsured"
                                        id="PartialDisablementForInsured1" [value]="3000"
                                        (change)="AddCovers('501809',3000)" />
                                    {{'SR 3000'| translate }}
                                </label>
                                <label>
                                    <input type="radio" name="PartialDisablementForInsured"
                                        id="PartialDisablementForInsured2" [value]="5000"
                                        (change)="AddCovers('501809',5000)" />
                                    {{'SR 5000' | translate}}
                                </label>
                                <label>
                                    <input type="radio" name="PartialDisablementForInsured"
                                        id="PartialDisablementForInsured3" [value]="10000"
                                        (change)="AddCovers('501809',10000)" />
                                    {{'SR 10000'| translate }}
                                </label>
                                <label>
                                    <input type="radio" name="PartialDisablementForInsured"
                                        id="PartialDisablementForInsured4" [value]="15000"
                                        (change)="AddCovers('501809',15000)" />
                                    {{'SR 15000' | translate}}
                                </label>
                                <label>
                                    <input type="radio" name="PartialDisablementForInsured"
                                        id="PartialDisablementForInsured4" [value]="15000"
                                        (change)="AddCovers('501809',0)" />
                                    {{'None' | translate}}
                                </label>
                            </label>
                        </div>
                        <div class="col-lg-12 coverdetails" style="margin:20px;" *ngIf="ShowAddBeneficiary">
                            <button type="button" class="btn btn-sm btn-primary btnbeneficiary"
                                (click)="ShowBeneficiaryModal()">{{'Add Beneficiary Details'|translate}}</button>
                            <!-- <button type="button" class="btn btn-sm btn-primary btnbeneficiary"
                                (click)="ViewBeneficiaryModal()">{{'View Beneficiary Details'|translate}}</button> -->
                            <a style="color: green; text-decoration: underline;font-size: 12px;"
                                onMouseOver="this.style.color='maroon'" onMouseOut="this.style.color='green'"
                                (click)="ViewBeneficiaryModal()">{{'View Beneficiary Details'|translate}}</a>
                        </div>

                    </div>


                    <div class="col-lg-12 Field">
                        <label class="AdditionalDrivers">
                            {{'Do you have claims in last 5 years ? ' | translate }}
                        </label>
                        <label class="AdditionalDrivers">
                            <label>
                                <input type="radio" name="ClaimsinLastFiveYears" id="ClaimsinLastFiveYears1"
                                    [value]="true" [(ngModel)]="ClaimsinLastFiveYears"
                                    (change)="AddClaimDetails($event,ClaimsinLastFiveYears)" />
                                {{'Yes'| translate }}
                            </label>
                            <label>
                                <input type="radio" name="ClaimsinLastFiveYears" id="ClaimsinLastFiveYears2"
                                    [value]="false" [(ngModel)]="ClaimsinLastFiveYears"
                                    (change)="AddClaimDetails($event,ClaimsinLastFiveYears)" />
                                {{'No' | translate}}
                            </label>
                        </label>
                    </div>

                    <!-- Display Claims Start  -->

                    <div class="col-lg-12 coverdetails FamilyGrid" *ngIf="ShowAddClaimBtn">
                        <div class="panel panel-default panel-table">
                            <div class="panel-heading">
                                <div class="row">
                                    <div class="col col-xs-6">
                                        <h3 class="panel-title">{{'Claims'|translate}}</h3>
                                    </div>
                                    <div class="col col-xs-6 text-right">
                                        <a type="button" class="btn btn-sm btn-primary btn-create"
                                            (click)="ShowClaimModal()">{{'Add Claim Details'|translate}}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="panel-body">
                                <table class="table table-striped table-bordered table-list">
                                    <thead>
                                        <tr>
                                            <th>{{'Year'|translate}}</th>
                                            <th>{{'Details'|translate}}</th>
                                            <th>{{'Claimed Amount'|translate}}</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let claim of objProposal.ClaimsHistory">
                                            <td>{{claim.ClaimYear}}</td>
                                            <td>{{claim.Details}}</td>
                                            <td>{{claim.Amount}}</td>

                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!-- Display Claims End  -->


                    <div class="col-lg-12 Field">
                        <label class="AdditionalDrivers proposaldeclined">
                            {{'Has any proposal for insurance ever been declined or has such insurance been cancelled or renewalrefused or special terms imposed ? ' | translate }}
                        </label>
                        <label class="AdditionalDrivers">
                            <label>
                                <input type="radio" name="ProposalDeclined" id="ProposalDeclined1" [value]="true" />
                                {{'Yes'| translate }}
                            </label>
                            <label>
                                <input type="radio" name="ProposalDeclined" id="ProposalDeclined2" [value]="false" />
                                {{'No' | translate}}
                            </label>
                        </label>
                    </div>
                    <div class="col-lg-12 DomesticBenefitcol" *ngIf="ShowProposalDeclined">
                        <input class="form-control" name="ProposalDeclinedText" id="ProposalDeclinedText"
                            [(ngModel)]="ProposalDeclinedText">
                    </div>
                </div>


                <!-- IBAN Fields Start -->
                <div class="DomesticField row">
                    <div class="col-lg-6 col-md-8 col-sm-12 col-xs-12">
                        <div class="col-lg-12">
                            <label class="Domesticlbltext">{{'IBAN Number'| translate }}</label>
                        </div>

                        <div class="row col-lg-12 bankdomesticrow">
                            <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4 domesticibancol">
                                <div class="input-group groupItems">
                                    <div class="input-group-addon">SA</div>
                                    <input type="text" class="form-control" id="txtIBAN1" numbersOnly name="txtIBAN1"
                                        [(ngModel)]="objProposal.IBAN1" maxlength="2" #txtIBAN1
                                        [value]="txtIBAN1.value.toUpperCase()" (ngModelChange)="iban1Changed($event)" />
                                </div>
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4 domesticibancol">
                                <input type="text" class="form-control" id="txtIBAN2" numbersOnly name="txtIBAN2"
                                    [(ngModel)]="objProposal.IBAN2" maxlength="4"
                                    [disabled]="objProposal.IBAN1?.length!=2" #txtIBAN2
                                    [value]="txtIBAN2.value.toUpperCase()" (ngModelChange)="iban2Changed($event)" />
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4 domesticibancol">
                                <input type="text" class="form-control" numbersOnly id="txtIBAN3" name="txtIBAN3"
                                    [(ngModel)]="objProposal.IBAN3" maxlength="4"
                                    [disabled]="objProposal.IBAN2?.length!=4" #txtIBAN3
                                    [value]="txtIBAN3.value.toUpperCase()" (ngModelChange)="iban3Changed($event)" />
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4 domesticibancol">
                                <input type="text" class="form-control" id="txtIBAN4" numbersOnly name="txtIBAN4"
                                    [(ngModel)]="objProposal.IBAN4" maxlength="4"
                                    [disabled]="objProposal.IBAN3?.length!=4" #txtIBAN4
                                    [value]="txtIBAN4.value.toUpperCase()" (ngModelChange)="iban4Changed($event)" />
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4 domesticibancol">
                                <input type="text" class="form-control" id="txtIBAN5" numbersOnly name="txtIBAN5"
                                    [(ngModel)]="objProposal.IBAN5" maxlength="4"
                                    [disabled]="objProposal.IBAN4?.length!=4" #txtIBAN5
                                    [value]="txtIBAN5.value.toUpperCase()" (ngModelChange)="iban5Changed($event)" />
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4 domesticibancol">
                                <input type="text" class="form-control" id="txtIBAN6" numbersOnly name="txtIBAN6"
                                    [(ngModel)]="objProposal.IBAN6" maxlength="4"
                                    [disabled]="objProposal.IBAN5?.length!=4" #txtIBAN6
                                    [value]="txtIBAN6.value.toUpperCase()" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="DomesticField row">
                    <div class="col-lg-6">
                        <label class="Domesticlbltext">{{'Bank Name'| translate }}</label>
                        <select class="form-control" [(ngModel)]="objProposal.BankCode" [disabled]="true">
                            <option [value]=""> --{{'Select Bank'| translate }}---</option>
                            <option [value]="Bank.BankCode" *ngFor="let Bank of objProposal.bankList">
                                {{Lng=="en"?Bank.BankDesc_Eng:Bank.BankDesc_Ar}}</option>
                        </select>
                    </div>
                </div>
                <!-- IBAN Fields End -->

                <div class="row btnsdomesticpremium">
                    <button class="btn btn-primary btnprevious" (click)="Prev()">{{'Prev' | translate}}</button>
                    <button class="btn btn-primary btnsaveprop"
                        (click)="SaveProposal()">{{'Save Proposal' | translate}}</button>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Add Claims Model Start  -->
<div class="modal" id="AddClaimsModal" role="dialog" role="dialog" [ngClass]="{'fade in':modal}">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="closemodal()">&times;</button>
                <h4 class="modal-title logins">{{'Please Provide Claim Details'| translate}}</h4>
            </div>
            <div class="modal-body">
                <div class="claimdetails">
                    <form #AddClaimForm="ngForm">
                        <div class="row">
                            <div class="col-lg-12" style="margin:10px 0px;">
                                <label class="Domesticlbltext lblclaim">{{ 'Year' | translate }}</label>
                                <input type="text" class="form-control DomesticClaimInput" id="txtYear" name="txtYear"
                                    required [(ngModel)]="objClaims.ClaimYear" #txtYear="ngModel" numbersOnly
                                    minlength="4" maxlength="4" (blur)="ValidateYear($event.target.value)" />
                                <span *ngIf="txtYear.invalid && (txtYear.dirty || txtYear.touched || isSubmitted)"
                                    class="text-danger valid">
                                    <div class="modalvalidation" *ngIf="txtYear.errors.required">
                                        {{'Claim Year is required'|translate }}
                                    </div>
                                    <div *ngIf="txtYear.errors?.minlength">
                                        {{ 'Yesr must be 4 digits' | translate}}</div>
                                    <div *ngIf="txtYear.errors?.maxlength">
                                        {{ 'Yesr No must be 4 digits' | translate}}</div>
                                </span>
                            </div>
                            <div class="col-lg-12" style="margin:10px 0px;">
                                <label class="Domesticlbltext lblclaim">{{ 'Details' | translate }}</label>
                                <input type="text" class="form-control DomesticClaimInput" required id="txtDetails"
                                    name="txtDetails" required [(ngModel)]="objClaims.Details" #txtDetails="ngModel" />
                                <span
                                    *ngIf="txtDetails.invalid && (txtDetails.dirty || txtDetails.touched || isSubmitted)"
                                    class="text-danger valid">
                                    <div class="modalvalidation" *ngIf="txtDetails.errors.required">
                                        {{'Claim Details is required'|translate }}
                                    </div>
                                </span>
                            </div>
                            <div class="col-lg-12" style="margin:10px 0px;">
                                <label class="Domesticlbltext lblclaim">{{ 'Claimed Amount' | translate }}</label>
                                <input type="text" class="form-control DomesticClaimInput" required
                                    id="txtClaimedAmount" name="txtClaimedAmount" required
                                    [(ngModel)]="objClaims.Amount" #txtClaimedAmount="ngModel" numbersOnly minlength="4"
                                    maxlength="9" />
                                <span
                                    *ngIf="txtClaimedAmount.invalid && (txtClaimedAmount.dirty || txtClaimedAmount.touched || isSubmitted)"
                                    class="text-danger valid">
                                    <div class="modalvalidation" *ngIf="txtClaimedAmount.errors.required">
                                        {{'Claimed Amount is required'|translate }}
                                    </div>
                                </span>
                            </div>
                            <div class="col-lg-12" style="display:flex;justify-content:center;margin:15px 0px;">
                                <button class="btn btn-primary"
                                    (click)="AddClaim(AddClaimForm.valid)">{{'Add Claim' | translate}}</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Add Claims Model End  -->






<div class="modal" id="AddClaimsModal" role="dialog" role="dialog" [ngClass]="{'fade in':modal1}">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">

                <button type="button" class="close" (click)="closemodal1()">&times;</button>
                <h4 class="modal-title logins">{{'Beneficiary Details of Insured Person'| translate}}</h4>
            </div>
            <div class="modal-body">
                <div class="claimdetails">
                    <form #AddBeneficiaryForm="ngForm">
                        <div class="row">
                            <div class="col-lg-12" style="margin:10px 0px;">
                                <label class="Domesticlbltext lblclaim">{{ 'Name' | translate }}</label>
                                <input type="text" class="form-control DomesticClaimInput" required id="txtName"
                                    name="txtName" required [(ngModel)]="ObjBeneficiaryList.Name" #txtName="ngModel" />
                                <span *ngIf="txtName.invalid && (txtName.dirty || txtName.touched )"
                                    class="text-danger valid">
                                    <div class="modalvalidation" *ngIf="txtName.errors.required">
                                        {{'Beneficiary Name is required'|translate }}
                                    </div>
                                </span>
                            </div>

                            <!-- <div class="col-lg-12" style="margin:10px 0px;">
                                <label class="Domesticlbltext lblclaim">{{ 'Relationship' | translate }}</label>
                                <input type="text" class="form-control DomesticClaimInput" required id="txtRelation"
                                    name="txtRelation" required [(ngModel)]="ObjBeneficiaryList.Relationship"
                                    #txtRelation="ngModel" />
                                <span
                                    *ngIf="txtRelation.invalid && (txtRelation.dirty || txtRelation.touched || isBenSubmitted)"
                                    class="text-danger valid">
                                    <div class="modalvalidation" *ngIf="txtRelation.errors.required">
                                        {{'Beneficiary Relation is required'|translate }}
                                    </div>
                                </span>
                            </div> -->

                            <div class="col-lg-12">
                                <label class="lbltext">{{'Relationship'| translate }}</label>
                                <select id="txtBeneficiaryRelation" selectRequired name="txtBeneficiaryRelation"
                                    class="form-control" [(ngModel)]="ObjBeneficiaryList.Relationship"
                                    #txtBeneficiaryRelation="ngModel">
                                    <option [value]="0">{{'Select Relation With Insured'| translate }}</option>
                                    <option *ngFor="let relObj of objProposal.relationList" [value]="relObj.RelationId">
                                        {{ Lng=="en"? relObj.RelationNameEn:relObj.RelationNameAr }}</option>
                                </select>
                                <span
                                    *ngIf="txtBeneficiaryRelation.invalid && (txtBeneficiaryRelation.dirty ||  txtBeneficiaryRelation.touched)"
                                    class="text-danger valid">
                                    <div *ngIf="txtBeneficiaryRelation.errors?.selectRequired">
                                        {{'Relation with Insured is required'| translate }}
                                    </div>
                                </span>
                            </div>

                            <div class="col-lg-12" style="margin:10px 0px;">
                                <label class="Domesticlbltext lblclaim">{{ 'Contact No' | translate }}</label>
                                <input type="text" class="form-control DomesticClaimInput" required id="txtContact"
                                    name="txtContact" required [(ngModel)]="ObjBeneficiaryList.ContactNo"
                                    #txtContact="ngModel" minlength="9" maxlength="9" pattern="^[5]\d{8}$" />
                                <span *ngIf="txtContact.invalid && (txtContact.dirty || txtContact.touched )"
                                    class="text-danger valid">
                                    <div class="modalvalidation" *ngIf="txtContact.errors.required">
                                        {{'Beneficiary Contact No is required'|translate }}
                                    </div>
                                    <div class="modalvalidation" *ngIf="txtContact.errors?.pattern">
                                        {{'Contact No Should Start With 5 and 9 digits'|translate }}
                                    </div>
                                </span>
                            </div>
                            <div class="col-lg-12" style="margin:10px 0px;">
                                <label class="Domesticlbltext lblclaim">{{ 'Email ID' | translate }}</label>
                                <input type="text" class="form-control DomesticClaimInput" required id="txtEmailId"
                                    name="txtEmailId" required [(ngModel)]="ObjBeneficiaryList.EMail"
                                    #txtEmailId="ngModel"
                                    pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(?!\.)(?!.*?\.\.)(?!.*\.$)[a-zA-Z.]{2,10}$" />
                                <span *ngIf="txtEmailId.invalid && (txtEmailId.dirty || txtEmailId.touched )"
                                    class="text-danger valid">
                                    <div class="modalvalidation" *ngIf="txtEmailId.errors.required">
                                        {{'Beneficiary Email ID is required'|translate }}
                                    </div>
                                    <p *ngIf="txtEmailId.errors.pattern && txtEmailId.invalid && txtEmailId.touched ">
                                        {{'Invalid Email Format'|translate}} </p>
                                </span>
                            </div>
                            <div class="col-lg-12" style="margin:10px 0px;">
                                <label class="Domesticlbltext lblclaim">{{ 'Address' | translate }}</label>
                                <input type="text" class="form-control DomesticClaimInput" required id="txtAddress"
                                    name="txtAddress" required [(ngModel)]="ObjBeneficiaryList.BeneficiaryAddress"
                                    #txtAddress="ngModel" />
                                <span *ngIf="txtAddress.invalid && (txtAddress.dirty || txtAddress.touched )"
                                    class="text-danger valid">
                                    <div class="modalvalidation" *ngIf="txtAddress.errors.required">
                                        {{'Beneficiary Address is required'|translate }}
                                    </div>
                                </span>
                            </div>

                            <div class="col-lg-12" style="display:flex;justify-content:center;margin:15px 0px;">
                                <button class="btn btn-primary"
                                    (click)="AddBeneficiary(AddBeneficiaryForm.valid)">{{'Add Beneficiary' | translate}}</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="modal" id="AddClaimsModal" role="dialog" role="dialog" [ngClass]="{'fade in':modal2}">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">

                <button type="button" class="close" (click)="closemodal2()">&times;</button>
                <h4 class="modal-title logins">{{'Beneficiary Details of Insured Person'| translate}}</h4>
            </div>
            <div class="modal-body" style="height: 500px; overflow: scroll;">
                <div class="claimdetails">
                    <div class="DomesticField row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"
                            *ngFor="let Beneficiary of objProposal.BeneficiaryDetails;let i=index;">
                            <div class="beneficiarycard">
                                <ul class="nav nav-tabs Sublistdata" role="tablist">
                                    <li role="presentation" class="active">
                                        <a href="#home" aria-controls="home" class="beneficiarycardheading" role="tab"
                                            data-toggle="tab">{{'Beneficiary Details' | translate }}</a>
                                        <span class="DelDriver" (click)="removeBeneficiary(i)">X</span>
                                    </li>
                                </ul>
                                <div class="tab-content">
                                    <div role="tabpanel" class="tab-pane active PolicyInfo">
                                        <label class="benelabel">
                                            <span class="lbltext">{{ 'Name'| translate }}:</span>
                                            <span class="dompremiumlbl">
                                                {{Beneficiary.Name}}</span>
                                        </label>

                                        <!-- <label class="benelabel">
                                            <span class="lbltext">{{'Relationship'| translate }}:</span>
                                            <span>
                                                {{Beneficiary.Relationship}}</span>
                                        </label> -->


                                        <label class="benelabel">
                                            <span class="lbltext">{{'Relationship'| translate }}:</span>
                                            <span  class="dompremiumlbl">
                                                <select style="height: 35px;width: 130%;font-size: smaller;" id="txtBeneficiaryRelation"
                                                    selectRequired name="txtBeneficiaryRelation" class="form-control"
                                                    [(ngModel)]="Beneficiary.Relationship"
                                                    #txtBeneficiaryRelation="ngModel" disabled="true">
                                                    <option [value]="0">{{'Select Relation With Insured'| translate }}
                                                    </option>
                                                    <option *ngFor="let relObj of objProposal.relationList"
                                                        [value]="relObj.RelationId">
                                                        {{ Lng=="en"? relObj.RelationNameEn:relObj.RelationNameAr }}
                                                    </option>
                                                </select></span>
                                        </label>


                                        <label class="benelabel">
                                            <span class="lbltext">{{'Contact NO'| translate }}:</span>
                                            <span>
                                                {{Beneficiary.ContactNo}}</span>
                                        </label>
                                        <label class="benelabel">
                                            <span class="lbltext">{{'Email ID'| translate }}:</span>
                                            <span class="dompremiumlbl">
                                                {{Beneficiary.EMail}}</span>
                                        </label>
                                        <label class="benelabel">
                                            <span class="lbltext">{{'Address'| translate }}:</span>
                                            <span class="dompremiumlbl">
                                                {{Beneficiary.BeneficiaryAddress}}</span>
                                        </label>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/DomesticHelperPortal/DomesticPremiumInfo/DomesticPremiumInfo.html